/*
 *  Buttons.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import styled from "styled-components";
import { Link } from "react-router-dom";
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const ButtonStyle = `
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  height: 100%;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0.04em;
  border: 1px solid #E8E8EB;
  appearance: none;
  user-select: none;
  cursor: pointer;
  transition: .2s all;
  &:disabled {
    color: #a2a7b3;
    cursor: not-allowed;
  }
`;
const OutlinedStyle = `
  ${ButtonStyle}
  color: #4C4F55;
  background-color: #fff;
  &:hover {
    background-color: #F8F8FB;
  };
  &:disabled:hover {
    background-color: #fff;
  }
`;

const PrimaryStyle = `
  ${ButtonStyle}
  color: #1E22FF;
  background-color: #E9E9FF;
  &:hover {
    background-color: #DFDFF5;
  };
  &:disabled {
    background-color: #f1f1ff;
    &:hover {
      background-color: #f1f1ff;
    };
  }
`;

// TODO: figure out how not to duplicate prop based styling
export const CustomButton = styled.button`
  ${(props) => `
    padding: ${props.small ? "4px 4px" : "8px 12px"};
    border-radius: ${props.borderRadius || "4px"};
  `}
`;
export const CustomAnchor = styled.a`
  ${(props) => `
    padding: ${props.small ? "4px 4px" : "8px 12px"};
    border-radius: ${props.borderRadius || "4px"};
  `}
`;
export const CustomLink = styled(Link)`
  ${(props) => `
    padding: ${props.small ? "4px 4px" : "8px 12px"};
    border-radius: ${props.borderRadius || "4px"};
  `}
`;

export const ButtonOutlined = styled(CustomButton)`
  ${OutlinedStyle}
`;
export const ButtonOutlinedAnchor = styled(CustomAnchor)`
  ${OutlinedStyle}
`;
export const ButtonOutlinedLink = styled(CustomLink)`
  ${OutlinedStyle}
`;
export const ButtonPrimary = styled(CustomButton)`
  ${PrimaryStyle}
`;
export const ButtonPrimaryAnchor = styled(CustomAnchor)`
  ${PrimaryStyle}
`;
export const ButtonPrimaryLink = styled(CustomLink)`
  ${PrimaryStyle}
`;
